// extracted by mini-css-extract-plugin
export var contentWrapper = "PrivacyAndToSTemplate-module--contentWrapper--2BQ0L";